/* NOOR — client-side wishlist heart toggle (localStorage only, no backend) */
(function () {
  var STORAGE_KEY = 'noorWishlist';

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(ids) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {}
  }

  function paintButton(btn, isActive) {
    btn.classList.toggle('is-active', isActive);
    btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  }

  function init() {
    var wishlist = readWishlist();
    document.querySelectorAll('[data-noor-wishlist]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      paintButton(btn, wishlist.indexOf(id) !== -1);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var list = readWishlist();
        var idx = list.indexOf(id);
        if (idx === -1) {
          list.push(id);
        } else {
          list.splice(idx, 1);
        }
        writeWishlist(list);
        paintButton(btn, idx === -1);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();